<template>
  <div class="controls">

    <div>
      <button id="camera" v-touch:tap="tapHandler" v-touch:touchhold="tapHandler">
        <!--        <font-awesome-icon size="lg" color="#00d6ff" icon="camera"/>-->
        <div class="filler" :style="fillerStyle"></div>
      </button>
    </div>
    <!--    <div class="controls_icon" @click="showFilter" v-if="!showFilters">-->
    <!--      <font-awesome-icon color="#fff" class="" icon="theater-masks"/>-->
    <!--    </div>-->
    <Filters v-if="showFilters && $route.name!=='masque'" :tapHandler="tapHandler"/>

  </div>

</template>

<script>
import {store} from '../../../store/store';
import Filters from "../Widgets/Filters";
import {mapState, mapActions} from "vuex";


export default {
  name: 'Camera',
  components: {
    Filters,
  },
  props: {
    streamingCanvas: HTMLCanvasElement,
    saveMedia: {type: Function},
  },
  computed: {
    fillerStyle() {
      return {transform: 'scaleY(' + this.percentage + ')'}
    },
    ...mapState([
      "user",
      "showFilters",
      "showPicture",
      "currentMask"
    ])
  },
  data() {
    return {
      store,
      recordButton: {},
      percentage: 0,
      mediaSource: {},
      stream: {},
      setInterval: null,
      currentTime: 0,
      mediaRecorder: {},
      recordedBlobs: [],
      isRecording: false,
      qrcode_uid: this.$route.params.qrcode_uid,

    }
  },
  mounted() {
    // this.recordButton = document.querySelector('button#record');
    // this.mediaSource = new MediaSource();
    // let sourceBuffer;
    // this.mediaSource.addEventListener('sourceopen', handleSourceOpen, false);
    //
    // this.stream = this.streamingCanvas.captureStream(); // frames per second
    //
    // function handleSourceOpen() {
    //   sourceBuffer = this.mediaSource.addSourceBuffer('video/webm; codecs="vp8"');
    // }

  },

  methods: {
    ...mapActions(['addPicture']),
    tapHandler(e) {
      if (threestuff) {
        if (e.type === 'touchstart') {
          this.isRecording = true;
          this.startRecording();
        } else {
          !this.isRecording && this.capture();
          this.isRecording && this.stopRecording();
        }
      } else {
        alert('aucun masque selectioné \nScannez un masque ou cliquez sur la liste ')
      }

    },
    getCurrentTime() {
      this.setInterval = setInterval(() => {
        this.currentTime += 1;
        this.percentage = this.currentTime / 10;
        if (this.currentTime === 10) {
          this.stopRecording();
          clearInterval(this.setInterval);
        }
      }, 1000);

    },
    stopRecording() {
      this.mediaRecorder.stop();
      clearInterval(this.setInterval);
      this.isRecording = false;
      this.currentTime = 0;
      document.getElementById("camera").style.zIndex = "0";
    },
    async startRecording() {
      document.getElementById("camera").style.zIndex = "20"

      let options = {mimeType: 'video/webm'};
      this.recordedBlobs = [];
      try {
        await navigator.mediaDevices.getUserMedia({
          'audio': true,
          'video': {
            facingMode: 'user'
          }
        })
        this.mediaRecorder = new MediaRecorder(this.stream, options);
      } catch (e0) {
        try {
          options = {mimeType: 'video/webm,codecs=vp9'};
          this.mediaRecorder = new MediaRecorder(this.stream, options);
        } catch (e1) {
          console.log('Unable to create MediaRecorder with options Object: ', e1);
          try {
            options = 'video/vp8'; // Chrome 47
            this.mediaRecorder = new MediaRecorder(this.stream, options);
          } catch (e2) {
            alert('MediaRecorder is not supported by this browser.\n\n' +
                'Try Firefox 29 or later, or Chrome 47 or later, ' +
                'with Enable experimental Web Platform features enabled from chrome://flags.');
            console.error('Exception while creating MediaRecorder:', e2);
            return;
          }
        }
      }
      this.mediaRecorder.onstop = this.handleStop;
      this.mediaRecorder.ondataavailable = this.handleDataAvailable;
      this.mediaRecorder.start(100); // collect 100ms of data
      this.getCurrentTime();
    },
    handleDataAvailable(event) {
      if (event.data && event.data.size > 0) {
        this.recordedBlobs.push(event.data);
      }
    },
    playPreview(video, superBuffer) {
      const preview = document.createElement('video');
      // const sourceMP4 = document.createElement("source");
      preview.style.transform = "translate(0, 0) rotateY(180deg)";
      preview.id = "mediaPreview";
      preview.style.zIndex = "-1";
      preview.autoplay = true;
      preview.loop = true;
      document.querySelector('#deviceready').appendChild(preview);
      // sourceMP4.type = "video/webm";
      const reader = new FileReader();

      reader.onload = (e) => {
        video.sources = [
          {
            src: e.target.result,
            type: 'video/webm',
          },
        ];
        preview.src = e.target.result;
        // preview.appendChild(sourceMP4);
        document.getElementById("mediaPreview").onloadedmetadata = () => {
          video.duration = "10s";
          this.addMedia(video);
          this.saveMedia(video.sources[0].src);

        };
      };
      reader.readAsDataURL(superBuffer);
    },

    handleStop() {
      const superBuffer = new Blob(this.recordedBlobs, {type: 'video/webm'});
      let webGLTestCanvas = document.createElement('canvas');
      const ctx = webGLTestCanvas.getContext('2d');

      ctx.drawImage(this.streamingCanvas, 0, 0, 640, 480);
      const video = {
        id: `video_${Math.random().toString(36).substr(2, 9)}`,
        thumb: {type: "img", src: this.streamingCanvas.toDataURL("image/jpg")},
        type: "video",
        width: document.body.clientWidth,
        height: 600,
        autoplay: true,
        loop: true,
      }

      this.playPreview(video, superBuffer);

    },
    capture() {
      let objectActive = threestuff.faceObjects.filter(el => el.visible).length;

      if (objectActive > 0) {
        store.state.showPicture = true
        let webGLTestCanvas = document.createElement('canvas');
        const ctx = webGLTestCanvas.getContext('2d');
        ctx.drawImage(this.streamingCanvas, 0, 0, 640, 480);
        const imgUri = this.streamingCanvas.toDataURL("image/png");
        const preview = document.createElement('img');
        preview.style.transform = "translate(0, 0) rotateY(180deg)";
        preview.id = "mediaPreview";
        preview.style.zIndex = "-1";
        preview.src = imgUri;

        // document.querySelector('#deviceready').appendChild(preview);

        // this.addPicture({
        //   id: `img_${Math.random().toString(36).substr(2, 9)}`,
        //   type: "img",
        //   src: imgUri,
        //   thumb: imgUri,
        // });
        document.querySelector('#jeeFaceFilterCanvas').style.display = "none";

        this.saveMedia({
          id: `img_${Math.random().toString(36).substr(2, 9)}`,
          type: "img",
          canvas: document.querySelector('#jeeFaceFilterCanvas'),
          src: imgUri,
          thumb: imgUri,
          duplicate: objectActive,
          order: this.currentMask.order,
          qrcode_uid: document.querySelector('.active').dataset.qrcode,
        });
      } else {
        alert("AUCUN MASQUE")
      }


    },
  }
}

</script>

<style>
.controls {
  display: flex;
  /*height: 100px;*/
  width: 100%;
  position: absolute;
  z-index: 1;
  bottom: calc(30px + env(safe-area-inset-bottom));
  justify-content: center;
  align-items: center;
}

.controls .hideFilters {
  position: absolute;
  z-index: 100;
  bottom: -26px;
  margin: 0;
  left: 50%;
  transform: translateX(-50%);
}

.controls > * {
  margin: 0 25px;
  padding-bottom: env(safe-area-inset-bottom);
}

.controls .widgetContainer {
  margin: 0;
}

#mediaPreview {
  width: 100vw;
}


.filler {
  position: absolute;
  top: 0;
  transition: all .5s ease;
  transform-origin: 50% 0;
  background: rgba(0, 214, 255, .5);
  width: 100%;
  height: 100%;
}

#camera {
  overflow: hidden;
  position: relative;
  padding: 0;
  transition: all .5s;
  width: 80px;
  height: 80px;
  color: #fff;
  border: 4px solid #00d6ff;
  background: transparent;
  border-radius: 50%;
}

#camera:focus {
  outline: none;
  box-shadow: none;
}

@media screen and (max-width: 750px) {

}

</style>
